<div class="news-content">
  <!-- Search and Sort Controls - Only show when websocket is complete and data is saved -->
  <div *ngIf="shouldShowSearchAndSort()" class="news-controls">
    <div class="search-section">
      <div class="search-input-wrapper">
        <img src="assets/images/search-icon.svg" alt="Search" class="search-icon" aria-hidden="true">
        <input 
          type="text" 
          class="search-input" 
          placeholder="Enter keywords to search"
          [(ngModel)]="searchQuery" 
          (input)="onSearchInput()" 
          aria-label="Search news and updates" 
          autocomplete="off">
      </div>
    </div>
    
    <div class="sort-section">
      <div class="custom-dropdown sort-dropdown" 
           [class.open]="isSortDropdownOpen"
           (click)="toggleSortDropdown()">
        <div class="dropdown-selected">
          <span class="sort-label">SORT:</span>
          <span class="sort-value">{{ selectedSortOption }}</span>
          <span class="dropdown-arrow">▼</span>
        </div>
        <div class="dropdown-options" *ngIf="isSortDropdownOpen">
          <div 
            *ngFor="let option of sortOptions" 
            class="dropdown-option"
            [class.selected]="option === selectedSortOption"
            (click)="onSortOptionChange(option)">
            {{ option }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Simple Error Message -->
  <div *ngIf="errorMessage && !isNewsLoading && !newsAndUpdatesnodata" class="simple-error-message">
    <p>{{ errorMessage }}</p>
  </div>
  <div *ngIf="newsItems && newsItems.length > 0 && !errorMessage" class="news-list">
    <div *ngFor="let newsItem of paginatedNewsItems; let i = index" class="news-item">
      <div class="news-header" *ngIf="newsItem.title">
        <h4 class="news-title">{{ newsItem.title }}</h4>
      </div>
      <div class="news-synopsis" *ngIf="newsItem.synopsis">
        {{ newsItem.synopsis }}
      </div>
      <div class="news-footer" *ngIf="newsItem.link || newsItem.date">
        <a [href]="newsItem.link" target="_blank" class="news-link" *ngIf="newsItem.link" (click)="onLinkClick(newsItem.link)">
          <span class="news-link-text">{{getLinkText(newsItem.link)}}</span>
          ↗
        </a>
        <span class="news-date" *ngIf="newsItem.date">{{ newsItem.date }}</span>
      </div>
    </div>
  </div>
  
  <!-- Pagination Controls -->
  <div *ngIf="newsItems && newsItems.length > 0" class="pagination-container">
    <div class="pagination-layout">
      <div class="rows-per-page-section">
        <span class="rows-per-page-label">Rows per page:</span>
        <div class="custom-dropdown" 
             (click)="toggleDropdown()" 
             [class.open]="isDropdownOpen">
          <div class="dropdown-selected">
            {{ pageSize }}
            <span class="dropdown-arrow">▼</span>
          </div>
          <div class="dropdown-options" *ngIf="isDropdownOpen">
            <div 
              *ngFor="let size of pageSizeOptions" 
              class="dropdown-option"
              [class.selected]="size === pageSize"
              (click)="onPageSizeChangeCustom(size)">
              {{ size }}
            </div>
          </div>
        </div>
      </div>
      
      <div class="page-count-section">
        <span class="page-info">{{ startIndex }}-{{ endIndex }} of {{ newsItems.length }}</span>
      </div>
      
      <div class="pagination-buttons-section">
        <button 
          class="pagination-btn" 
          [disabled]="currentPage === 1"
          (click)="onPageChange(currentPage - 1)">
          ‹
        </button>
        
        <button 
          class="pagination-btn" 
          [disabled]="currentPage === totalPages"
          (click)="onPageChange(currentPage + 1)">
          ›
        </button>
      </div>
    </div>
  </div>
  
  <div *ngIf="!isresponseLoading && !isNewsLoading && newsAndUpdatesnodata && newsItems && newsItems.length === 0" class="no-news">
    <div class="no-news-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h3 class="no-news-title">No News Available</h3>
    <p class="no-news-text">There are no news and updates available at the moment. Please check back later.</p>
  </div>
</div> 